/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ResourceReference { 
    value?: string;
    ref?: string;
    display?: string;
    type?: ResourceReference.TypeEnum;
}
export namespace ResourceReference {
    export const TypeEnum = {
        Direct: 'direct',
        Indirect: 'indirect',
        User: 'User',
        Group: 'Group'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


